import { render } from "./App.vue?vue&type=template&id=25faad54"
const script = {}

import "./App.vue?vue&type=style&index=0&id=25faad54&lang=css"
script.render = render

export default script